export const SEARCH_USER_ASYNC = "SEARCH_USER_ASYNC";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const INVITE_USER_NON_SYSTEM_ASYNC = "INVITE_USER_NON_SYSTEM_ASYNC";
export const INVITE_USER_IN_SYSTEM_ASYNC = "INVITE_USER_IN_SYSTEM_ASYNC";
export const INVITE_USER_SUCCESS = "INVITE_USER_SUCCESS";
export const RESET_INVITE_USER = "RESET_INVITE_USER";
export const UPDATE_USER_ASYNC = "UPDATE_USER_ASYNC";
export const UPDATE_MY_PROFILE_ASYNC = "UPDATE_MY_PROFILE_ASYNC";
export const UPDATE_PROFILE_PHOTO_ASYNC = "UPDATE_PROFILE_PHOTO_ASYNC";
export const UPDATE_PROFILE_PHOTO_SUCCESS = "UPDATE_PROFILE_PHOTO_SUCCESS";
export const REMOVE_PROFILE_PHOTO_ASYNC = "REMOVE_PROFILE_PHOTO_ASYNC";
export const REMOVE_PROFILE_PHOTO_SUCCESS = "REMOVE_PROFILE_PHOTO_SUCCESS";
export const UPDATE_MY_PROFILE_SUCCESS = "UPDATE_MY_PROFILE_SUCCESS";
export const RESEND_INVITE_ASYNC = "RESEND_INVITE_ASYNC";
export const RESEND_CONFIRM_EMAIL_ASYNC = "RESEND_CONFIRM_EMAIL_ASYNC";
export const RESET_PASSWORD_ASYNC = "RESEND_RESET_PASSWORD_ASYNC";
export const REMOVE_USER_ASYNC = "REMOVE_USER_ASYNC";
export const GET_ALL_FAQ_ASYNC = "GET_ALL_FAQ_ASYNC";
export const GET_USER_BY_USERID_ASYNC = "GET_USER_BY_USERID_ASYNC";
export const GET_USER_BY_USERID_SUCCESS = "GET_USER_BY_USERID_SUCCESS";
export const GET_USER_BY_EMAIL_ASYNC = "GET_USER_BY_EMAIL_ASYNC";
export const GET_USER_BY_EMAIL_SUCCESS = "GET_USER_BY_EMAIL_SUCCESS";
export const EDIT_USER_ERROR = "EDIT_USER_ERROR";
export const OPEN_FORM_CHANGE_PASSWORD = "OPEN_FORM_CHANGE_PASSWORD";
export const CLOSE_FORM_CHANGE_PASSWORD = "CLOSE_FORM_CHANGE_PASSWORD";
export const CHANGE_PASSWORD_ASYNC = "CHANGE_PASSWORD_ASYNC";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const RESET_MANAGE_USER = "RESET_MANAGE_USER";
export const UPDATE_LOGO_COMPANY_ASYNC = "UPDATE_LOGO_COMPANY_ASYNC";
export const UPDATE_HO_LOGO_COMPANY_ASYNC = "UPDATE_HO_LOGO_COMPANY_ASYNC";
export const UPDATE_LOGO_COMPANY_SUCCESS = "UPDATE_LOGO_COMPANY_SUCCESS";
export const UPDATE_HO_LOGO_COMPANY_SUCCESS = "UPDATE_HO_LOGO_COMPANY_SUCCESS";
export const REMOVE_LOGO_COMPANY_ASYNC = "REMOVE_LOGO_COMPANY_ASYNC";
export const REMOVE_HO_LOGO_COMPANY_ASYNC = "REMOVE_HO_LOGO_COMPANY_ASYNC";
export const SUSPEND_USER_ASYNC = "SUSPEND_USER_ASYNC";
export const FETCH_USER_CLOSE_OPTION_ASYNC = "FETCH_USER_CLOSE_OPTION_ASYNC";
export const APPLY_BRANDING_TO_HOMEOWNERS_ASYNC = "APPLY_BRANDING_TO_HOMEOWNERS_ASYNC";



// WEBPACK FOOTER //
// ./src/User/constants.js